/* eslint-disable import/prefer-default-export */
const modules = Object.freeze({
    OPPORTUNITIES: 'opportunities',
    DEALS: 'deals',
    INVENTORY: 'inventory',
    SETTINGS: 'settings',
    ACCOUNTING: 'accounting',
    CUSTOMERS: 'customers',
    CRM: 'crm',
    CALENDAR: 'calendar',
    COMMUNICATION: 'communication',
    BHPH: 'bhph',
    QUERIES: 'queries',
    PAYROLL: 'payroll',
    REPORTS: 'reports',
    RULES: 'rules',
    PARTS: 'parts',
    SERVICE: 'service',
    FLOORLOG: 'floorlog',
    PREFERENCES: 'preferences',
    DASHBOARD: 'dashboard',
    CUSTOM_REPORTS: 'custom-reports',
    TRAINING: 'training',
    OTHER: 'other',
    EMPLOYEE_PERFORMANCE_REPORTS: 'employee-performance-reports',
    HR: 'hr',
    COLLECTIONS: 'collections',
});

const DOCUMENT_TYPES_AVAILABLE_MODULES = {
    ALL: 'all',
    ...Object.fromEntries(
        Object.entries(modules).filter(([key]) => [
            'DEALS',
            'INVENTORY',
            'ACCOUNTING',
            'CUSTOMERS',
            'CRM',
            'PARTS',
            'SERVICE',
            'COLLECTIONS',
            'SETTINGS',
            'HR',
        ].includes(key)),
    ),
};

const HR_SUBMODULES = Object.freeze({
    ORGANIZATIONAL_CHART: 'dashboard',
    EMPLOYEE_SETTINGS: 'employee',
    ASSET_INVENTORY: 'assetinventory',
    CALENDAR: 'calendar',
    WORK_SCHEDULE: 'schedule',
    SETTINGS: 'hrsetting',
    LOCKED_USER: 'lockeduser',
});

const COLLECTIONS_SUBMODULES = Object.freeze({
    ACCOUNTS: 'accounts',
    QUEUE_ACCOUNT: 'queue-account',
    CREDIT_REPORTING: 'credit-reporting',
    SETTINGS_GENERAL: 'settings-general',
    MESSAGE_CENTER: 'message-center',
});

export {
    DOCUMENT_TYPES_AVAILABLE_MODULES,
    COLLECTIONS_SUBMODULES,
    HR_SUBMODULES,
    modules,
};
